import React from 'react';
import { Box, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SessionList from '@/components/Session/SessionList';
import NewSessionButton from '@/components/Session/NewSessionButton';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  width: number;
}

/**
 * 左侧会话列表容器，包含 SessionList 和 NewSessionButton。
 * 移动端使用 Drawer，桌面端固定显示。
 */
const Sidebar: React.FC<SidebarProps> = ({ open, onClose, width }) => {
  return (
    <>
      {/* 桌面端固定 Sidebar */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: open ? width : 0,
          flexShrink: 0,
          overflow: 'hidden',
          transition: 'width 0.3s ease',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            width,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            p: 1.5,
          }}
        >
          <NewSessionButton />
          <Box sx={{ flex: 1, overflow: 'auto', mt: 1 }}>
            <SessionList />
          </Box>
        </Box>
      </Box>

      {/* 移动端 Drawer */}
      <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        variant="temporary"
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width,
            boxSizing: 'border-box',
            bgcolor: 'background.paper',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ px: 1.5, pb: 1.5 }}>
          <NewSessionButton />
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', px: 1.5, pb: 1.5 }}>
          <SessionList />
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
